import React, { Component } from "react";
import "../Ventas/ventas.css";
import "./locaciones.css";
import { toast } from "react-toastify";
import { FaCheck, FaTimes } from "react-icons/fa";

import {
    getListaGeneralLocaciones,
    editarEstatusLocacion,
    getListaLocaciones, // <-- crea esta API (abajo te dejo ejemplo)
} from "../../service/api";
import Navbar from "../../componentes/navbar/navbar";
import ModalMessage from "../../componentes/modal/ModalMessages/ModalMessages";
import SpinnerModal from "../../componentes/spiner/SpinnerModal";

export default class LocacionesPage extends Component {
    state = {
        loading: false,
        locaciones: [],
        filterText: "",
        sortKey: "locacion",
        sortDir: "asc",

        // ModalMessage confirm
        verMensaje: false,
        accionEstatus: null, // "activar" | "deshabilitar"
        modalMessage: "",
        selectedLocacion: null,
    };

    componentDidMount() {
        const datos = localStorage.getItem("datosm");
        if (!datos || datos === "") {
            window.location.href = "/";
            return;
        }

        this.fetchLocaciones();
    }

    // ===== Helpers =====
    logoutByToken = () => {
        try {
            localStorage.removeItem("datosm");
            localStorage.removeItem("token"); // si usas "token"
            localStorage.clear();
        } catch (e) { }
        window.location.href = "/";
    };

    normalize = (l) => ({
        idlocacion: l?.idlocacion ?? null,
        locacion: l?.locacion ?? "",
        idestatus: Number(l?.idestatus ?? 0),
        _key: String(l?.idlocacion ?? Math.random()),
    });

    compareValues = (a, b) => {
        if (a == null) a = "";
        if (b == null) b = "";

        const na = Number(a);
        const nb = Number(b);

        const bothNumeric =
            !Number.isNaN(na) &&
            !Number.isNaN(nb) &&
            String(a).trim() !== "" &&
            String(b).trim() !== "";

        if (bothNumeric) return na - nb;

        return String(a).localeCompare(String(b), "es", {
            numeric: true,
            sensitivity: "base",
        });
    };

    getSortValue = (l, key) => {
        switch (key) {
            case "idlocacion":
                return l.idlocacion;
            case "locacion":
                return l.locacion;
            case "estatus":
                return l.idestatus;
            default:
                return "";
        }
    };

    onSort = (key) => {
        this.setState((prev) => {
            const same = prev.sortKey === key;
            const nextDir = same && prev.sortDir === "asc" ? "desc" : "asc";
            return { sortKey: key, sortDir: nextDir };
        });
    };

    getSortedItems = (items) => {
        const { sortKey, sortDir } = this.state;
        return [...(items || [])].sort((aa, bb) => {
            const a = this.getSortValue(aa, sortKey);
            const b = this.getSortValue(bb, sortKey);
            const cmp = this.compareValues(a, b);
            return sortDir === "asc" ? cmp : -cmp;
        });
    };

    setFilterText = (e) => {
        this.setState({ filterText: e.target.value || "" });
    };

    getFilteredItems = () => {
        const q = String(this.state.filterText || "").trim().toLowerCase();
        const items = this.state.locaciones || [];
        if (!q) return items;

        return items.filter((l) => {
            const s = [l.idlocacion, l.locacion, l.idestatus].join(" ").toLowerCase();
            return s.includes(q);
        });
    };

    // ===== API =====
    fetchLocaciones = async () => {
        this.setState({ loading: true });

        try {
            const resp = await getListaLocaciones();

            // Regla clave: token expirado
            if (resp && resp.code === 2003) {
                this.logoutByToken();
                return;
            }

            if (resp && resp.code === 0) {
                const raw = Array.isArray(resp.data) ? resp.data : [];
                const locaciones = raw.map(this.normalize);
                this.setState({ locaciones, loading: false });
                return;
            }

            toast.info(resp?.message || "No se pudieron obtener locaciones.");
            this.setState({ loading: false });
        } catch (e) {
            toast.info("Error al obtener locaciones.");
            this.setState({ locaciones: [], loading: false });
        }
    };

    // ===== UI: abrir confirmación =====
    openConfirmToggle = (row) => {
        if (!row?.idlocacion) return;

        const isActive = row.idestatus === 1;
        const accionEstatus = isActive ? "deshabilitar" : "activar";

        this.setState({
            verMensaje: true,
            accionEstatus,
            modalMessage: row.locacion,
            selectedLocacion: row,
        });
    };

    // ===== Modal: respuesta 0/1 =====
    completaBorrar = async (response) => {
        // 0 = cancelar
        if (response !== 1) {
            this.setState({
                verMensaje: false,
                accionEstatus: null,
                modalMessage: "",
                selectedLocacion: null,
            });
            return;
        }

        const row = this.state.selectedLocacion;
        if (!row?.idlocacion) return;

        const nextStatus = row.idestatus === 1 ? 0 : 1;

        this.setState({ loading: true, verMensaje: false });

        try {
            const r = await editarEstatusLocacion(row.idlocacion, nextStatus);

            if (r && r.code === 2003) {
                this.logoutByToken();
                return;
            }

            if (r && r.code === 0) {
                row.idestatus === 1 ?
                    toast.error("Locación deshabilitada.")
                    : toast.success("Locación habilitada.");
                //Estatus actualizado.");
                this.setState({
                    accionEstatus: null,
                    modalMessage: "",
                    selectedLocacion: null,
                });
                this.fetchLocaciones();
                return;
            }

            toast.info(`${r?.code} - ${r?.message || "No se pudo actualizar."}`);
            this.setState({ loading: false });
        } catch (e) {
            toast.info("Error al actualizar estatus de la locación.");
            this.setState({ loading: false });
        }
    };

    render() {
        const { loading, filterText, verMensaje, accionEstatus, modalMessage } = this.state;

        const filtered = this.getFilteredItems();
        const items = this.getSortedItems(filtered);

        return (
            <div className="v-page">
                <Navbar />

                {loading ? <SpinnerModal tipo="full" show={loading} /> : null}

                {verMensaje ? (
                    <ModalMessage
                        show={verMensaje}
                        titulo={accionEstatus === "activar" ? "Habilitar locación" : "Deshabilitar locación"}
                        bandera={accionEstatus === "activar" ? "activarLocacion" : "deshabilitarLocacion"}
                        mensaje={modalMessage}
                        cerrarBorrar={this.completaBorrar}
                    />
                ) : null}

                <div className="a-shell">
                    <div className="v-top">
                        <h1 className="v-title">Locaciones</h1>

                        <div className="a-actions">
                            <div className="so-search">
                                <span className="so-ico" aria-hidden="true">🔎</span>

                                <input
                                    type="text"
                                    value={filterText}
                                    onChange={(e) => this.setState({ filterText: e.target.value, selectedRowId: null })}
                                    placeholder="Buscar locación..."
                                    disabled={loading}
                                />

                                {String(filterText || "").length > 0 && (
                                    <button
                                        type="button"
                                        className="so-clear"
                                        onClick={() => this.setState({ filterText: "", selectedRowId: null })}
                                        disabled={loading}
                                        aria-label="Limpiar"
                                        title="Limpiar"
                                    >
                                        ✕
                                    </button>
                                )}
                            </div>

                            <button className="v-btn" onClick={this.fetchLocaciones} disabled={loading}>
                                ACTUALIZAR
                            </button>
                        </div>
                    </div>

                    <div className="vard">
                        <div className="v-card">
                            <div className="v-tableWrap">
                                <table className="v-table">
                                    <thead>
                                        <tr>

                                            <th className="v-thSort" onClick={() => this.onSort("locacion")}>
                                                Locación
                                            </th>
                                            <th className="v-thSort" onClick={() => this.onSort("estatus")}>
                                                Estatus
                                            </th>
                                            <th>Acción</th>
                                        </tr>
                                    </thead>

                                    <tbody>
                                        {items.length === 0 ? (
                                            <tr>
                                                <td colSpan="4" className="v-empty">
                                                    No hay registros disponibles
                                                </td>
                                            </tr>
                                        ) : (
                                            items.map((l, idx) => {
                                                const active = l.idestatus === 1;

                                                const rowClass = [idx % 2 === 0 ? "even" : "odd"].join(" ").trim();

                                                return (
                                                    <tr key={`${l._key}-${idx}`} className={rowClass}>
                                                        <td>{l.locacion}</td>

                                                        <td className="loc-status">
                                                            {active ? (
                                                                <span className="loc-pill active">
                                                                    <FaCheck style={{ marginRight: 6 }} />
                                                                    Activo
                                                                </span>
                                                            ) : (
                                                                <span className="loc-pill off">
                                                                    <FaTimes style={{ marginRight: 6 }} />
                                                                    Deshabilitado
                                                                </span>
                                                            )}
                                                        </td>

                                                        <td>
                                                            <button
                                                                className={`a-linkBtn ${active ? "danger" : ""}`}
                                                                onClick={() => this.openConfirmToggle(l)}
                                                                disabled={loading}
                                                                title={active ? "Deshabilitar" : "Habilitar"}
                                                            >
                                                                {active ? "Deshabilitar" : "Habilitar"}
                                                            </button>
                                                        </td>
                                                    </tr>
                                                );
                                            })
                                        )}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}